import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NoCookiesService {
  constructor() {
    this.deleteAllCookies();
    this.blockCookies();
  }

  private deleteAllCookies() {
    document.cookie.split(';').forEach(c => {
      document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/');
    });
  }

  private blockCookies() {
    try {
      Object.defineProperty(document, 'cookie', {
        configurable: true,
        enumerable: true,
        get: function() {
          return '';
        },
        set: function() {
          console.warn('🚫 Cookie blocked!');
          return true;
        }
      });
    } catch (err) {
      console.error('Could not override document.cookie:', err);
    }
  }
}